/* **** THIS TABLE AND ITS USAGE WILL BE REPLACED WITH THE NEW CUSTOM TABLE **** */
import { InfoOutlined } from '@mui/icons-material';
import { Table, TableBody, TableContainer, Tooltip } from '@mui/material';
import { useUserRole } from 'src/utils';

import { NoResultAlert } from '../../noResultAlert';
import { ICustomTable } from './LegacyCustomTable.interface';
import {
  CustomTableCell,
  CustomTableHead,
  CustomTableRow,
} from './LegacyCustomTable.styled';

export const LegacyCustomTable = <T extends string | number>({
  headers,
  items,
}: ICustomTable<T>) => {
  const { isViewOnly } = useUserRole();

  return items.length > 0 ? (
    <TableContainer>
      <Table stickyHeader>
        <CustomTableHead>
          <CustomTableRow>
            {headers.map((header) => (
              <CustomTableCell key={header.key} flex={header.flex}>
                {header.label}
                {!isViewOnly && header.tooltip && (
                  <Tooltip title={header.tooltip} placement="right">
                    <InfoOutlined color="secondary" />
                  </Tooltip>
                )}
              </CustomTableCell>
            ))}
          </CustomTableRow>
        </CustomTableHead>

        <TableBody>
          {items.map((item, index) => (
            <CustomTableRow key={index}>
              {headers.map((header) => (
                <CustomTableCell key={header.key} flex={header.flex}>
                  {item[header.key]}
                </CustomTableCell>
              ))}
            </CustomTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  ) : (
    <NoResultAlert />
  );
};
